import(/* webpackMode: "eager" */ "/app/apps/dtc-client/src/app/[lng]/qr/[qrId]/error.tsx");
